import { render, staticRenderFns } from "./ModalAssignSupervisors.vue?vue&type=template&id=7b127576&scoped=true&"
import script from "./ModalAssignSupervisors.vue?vue&type=script&lang=js&"
export * from "./ModalAssignSupervisors.vue?vue&type=script&lang=js&"
import style0 from "./ModalAssignSupervisors.vue?vue&type=style&index=0&id=7b127576&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b127576",
  null
  
)

export default component.exports